export default __webpack_public_path__ + "images/ac10576c2ff3724e58645caa052a5019-emoji-sad.svg";